export default __webpack_public_path__ + "static/media/RAIDER 125_4.9d2c2162.webp";